module.exports = __webpack_public_path__ + "img/30.4.NH3-N.c9f0fd9f.png";